import React from 'react';
import '../order.css'
import '../../assets/css/payment.css'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import api from '../../seller-apis/api';
const PaymentCard = (props) => {
    const dwnldInv = (_id, name) => {
        console.log(name)
        console.log("_id: ", _id)
        api.vendorledger.orderInvoice(_id).then((res) => {
            console.log(res);
            let blob = new Blob([res.data], { type: 'application/pdf' });
            var downloadURL = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = downloadURL;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(downloadURL);
            document.body.removeChild(a);
            // var newWindow = window.open(downloadURL);
            // newWindow.document.title = name;
        }).catch(err => console.log(err))
    }
    if (props.from === "transactions") {
        let trDate = undefined
        if (props.razorpayxDetails && props.razorpayxDetails !== null) {
            let date = new Date(props.razorpayxDetails.paymentDate);
            let d = date.toUTCString(props.razorpayxDetails.paymentDate);
            trDate = d.substr(4, 12)
        }
        //SL-907
        function isYesterday(dateString) {
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            const givenDate = new Date(dateString);
            return (
                givenDate.getDate() === yesterday.getDate() &&
                givenDate.getMonth() === yesterday.getMonth() &&
                givenDate.getFullYear() === yesterday.getFullYear()
            );
        }
        console.log('isYesterday(props.date',isYesterday(props.date))
        return (
            <>
                <tr 
                    className={`fs-14 payment_table_row ${isYesterday(props.date) ? "tr-yesterday" : ""}`} 
                >
                    <td className='order_table_date'>{props.date}</td>
                    <td className='order_table_date'> {props.orderId}</td>
                    <td className='order_table_date'>{props.orderStatus}</td>
                    <td className='fs-13 order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.transferPriceInclGst}</td>
                    {/**Platform Fee Ticket : SL-662 & I1-2262 */}
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props?.platformFee != null ? props.platformFee : 0}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.customerPriceExclGst}</td>
                    <td className='order_table_date'>{props.gstPercent}</td>

                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.customerPriceInclGst}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.tvCommissionInclGst}</td>
                    <td className='order_table_date'>{props.tds1Percent}</td>
                    <td className='order_table_date'>{props.tcs1Percent}</td>
                    <td className='order_table_date fw-bolder'><i class="fa fa-inr" aria-hidden="true"></i> {props.amountToRemitted}</td>
                    <td className='order_table_date'>{props.razorpayxDetails === null ? <>---</> : <>
                                {props.razorpayxDetails && props.razorpayxDetails.status}
                                <OverlayTrigger
                                    key="tcs"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id={`tooltip-tcs`} className="fs-12">
                                    <p className='fs-12 f-500 '>Transaction Id - {props.razorpayxDetails && props.razorpayxDetails.txId}
                                    </p>
                                    <p className='fs-12'>
                                        Date:- {trDate}
                                    </p>
                                        </Tooltip>
                                    }
                                >
                                    <i class="bi bi-info-circle ms-1"></i>
                                </OverlayTrigger>
                    </>}</td>
                </tr>
            </>
        )


    }
    else if (props.from === "orderSummary") {
        return (
            <>
                <tr className='fs-14 payment_table_row' key={props.orderId}>
                    <td className='order_table_date'>{props.date}</td>
                    <td className='order_table_date'> {props.orderId}</td>
                    <td className='order_table_date'>{props.orderStatus}<br></br>
                        {props.orderStatus != "cancelled" ?
                            <i className="fa fa-download" aria-hidden="true" onClick={() => dwnldInv(props.lead, props.invoiceNumber + "_" + props.orderId)}></i> : <></>}
                    </td>
                    <td className='fs-13 order_table_date'>{props.invoiceNumber}</td>
                    <td className='fs-13 order_table_pname_cntn'>
                        <span className='tool_colr'> {props.customerName}</span><br></br>
                        <div className='order_table_sku ff_Pop'>{props.customerState}</div>

                    </td>
                    <td className='order_table_date'>{props.gstNo}</td>
                    <td className='fs-13 order_table_pname_cntn p-1'>
                        <p className='ff_Pop'> {props.productName}</p>
                        <div className='order_table_sku'>SKU :- {props.sku}</div>

                    </td>
                    <td className='order_table_date'>{props.quantity}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.customerPriceExclGst}</td>
                    <td className='order_table_date'>{props.gstPercent}</td>
                    <td className=' fw-bolder'><i class="fa fa-inr" aria-hidden="true"></i> {props.customerPriceInclGst}</td>
                </tr>
            </>
        )
    }
    else if (props.from === "paymentdone") {
        return (
            <>
                <tr className='fs-14 payment_table_row'>
                    <td className='order_table_date'>{props.id + 1}</td>
                    <td className='order_table_date'> {props.paymentDate}</td>
                    <td className='order_table_date'>{props.txId}</td>
                    <td className='fs-13 order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.totalAmount}</td>
                    <td className='order_table_date'><u className='order_table_date' role="button" onClick={() => props.showpayhistory(props.id)}>Click here</u></td>
                </tr>
            </>
        )
    }
    else if (props.from === "paymentsonhold") {
        return (
            <>
                <tr className='fs-14 payment_table_row'>
                    <td className='order_table_date'>{props.id + 1}</td>
                    <td className='order_table_date'> {props.orderId}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.amount}</td>
                    <td className='fs-13 order_table_date'> {props.deliveredon}</td>
                    <td className='order_table_date text-black'>{props.reason}</td>
                </tr>
            </>
        )
    }
    else if (props.from === "paymentsDeduction" || props.from === "paymentsPenalty") {
        let reasonElements = []
        if (props?.item?.logisticCharge && props?.item?.logisticCharge > 0) {
            reasonElements.push(
                <span className='text-black'>Logistic Charges - <i class="fa fa-inr" aria-hidden="true"></i> {props?.item?.logisticCharge}</span>
            );
        }
        if (props?.item?.deductMargin && props?.item?.deductMargin > 0) {
            reasonElements.push(
                <span className='text-black'><br />Slab Wise Deduction Amount - <i class="fa fa-inr" aria-hidden="true"></i> {props?.item?.deductMargin}</span>
            );
        }
        if (props?.item?.twoPerAmount && props?.item?.twoPerAmount > 0) {
            reasonElements.push(
                <span className='text-black'><br />2% Penalty Deduction - <i class="fa fa-inr" aria-hidden="true"></i> {props?.item?.twoPerAmount}</span>
            );
        }
        if (props?.item?.compensationAmount && props?.item?.compensationAmount > 0) {
            reasonElements.push(
                <span className='text-black'><br />Compensation Amount - <i class="fa fa-inr" aria-hidden="true"></i> {props?.item?.compensationAmount}</span>
            );
        }
        if (props?.item?.otherAmount && props?.item?.otherAmount > 0) {
            reasonElements.push(
                <span className='text-black'><br />Other - <i class="fa fa-inr" aria-hidden="true"></i> {props?.item?.otherAmount}</span>
            );
        }

        // SL-2305
        if(props?.item?.subReason){
            reasonElements.push(
                <span className='text-black'>{props?.item?.subReason}</span>
            );
        }

        return (
            <>
                <tr className='fs-14 payment_table_row'>
                    <td className='order_table_date'>{props.id + 1}</td>
                    <td className='fs-13 order_table_date'> {props.deducton}</td>
                    <td className='order_table_date'> {props.orderId}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.amount}</td>
                    <td className='order_table_date text-black'>
                        {props?.reason && props?.reason !== "" ? props?.reason : props.requestForPayment !== "deduction" ? "Delay in Dispatch" : "Support Deduction Charges"} 
                        {reasonElements.length > 0 && (
                            <OverlayTrigger
                                key={"deduction" + props?.id}
                                placement="bottom"
                                overlay={
                                    <Tooltip id={"deduction" + props?.id} className="fs-16 order_page_tooltip deduction_tooltip">
                                        <p className='fs-10 f-500 payment_page_tooltip_1'>{reasonElements}</p>
                                    </Tooltip>
                                }
                            >
                                <i className="fa fa-info-circle ms-2" aria-hidden="true"></i>
                            </OverlayTrigger>
                        )}
                    </td>
                </tr>
            </>
        )
    }
      else if (props.from === "sellerReturns") {
        let customerDetails = props?.customerDetails
        return (
            <>
                <tr className='fs-14 payment_table_row' key={props.orderId}>
                    <td className='order_table_date'>{props.date}</td>
                    <td className='order_table_date'> {props.orderId}</td>
                    <td className='order_table_date seller_returns_332'> {props?.issueReportedOn}</td>
                    <td className='order_table_date'>{props?.reverseDocketStatus}
                    </td>
                    <td className='fs-13 order_table_date'>{props.invoiceNumber}</td>
                    <td className='fs-13 order_table_pname_cntn'>
                        <span className='tool_colr'> {customerDetails?.customerName}</span><br></br>
                        <div className='order_table_sku ff_Pop'>{customerDetails?.address}</div>
                        <div className='order_table_sku ff_Pop fw-bold'>{customerDetails?.state}</div>

                    </td>
                    <td className='fs-13 order_table_pname_cntn p-1'>
                        <p className='ff_Pop'> {props.productName}</p>
                        <div className='order_table_sku'>SKU :- {props.sku}</div>

                    </td>
                    <td className='order_table_date'>{props.quantity}</td>
                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {props.sellerPriceExclGst}</td>
                </tr>
            </>
        )
    }
}

export default PaymentCard